import type { CartItemData } from '../hooks/useAllUserMultiCartItemsMetadata'
import { sum } from 'lib/array/arrayUtils'
import { getUserCartItemDisplayTotals } from 'lib/userCart/userCartTotals'

export function getMultiCartGroupPublicTotal(
  multiCartItems: Array<App.MultiCartItem>,
  cartItemsData: Array<CartItemData>,
): number | undefined {
  const activeItemIds = new Set(
    multiCartItems
      .filter(item => item.state === 'active')
      .map(item => item.item.itemId),
  )

  if (activeItemIds.size === 0) {
    return
  }

  const groupCartItemsData = cartItemsData.filter(item => (
    activeItemIds.has(item.itemId) &&
    !item.isSavedForLater &&
    !item.isDeleted
  ))

  if (groupCartItemsData.length !== activeItemIds.size || groupCartItemsData.some(item => !item.itemTotals)) {
    return
  }

  return sum(groupCartItemsData, item => getUserCartItemDisplayTotals(item.itemTotals).publicTotal)
}
